// extracted by mini-css-extract-plugin
module.exports = {"d2xZ7":"Z7_d2xZ7__3bP6V"};